import React, { useCallback, useState } from "react";
import { Button } from "components/bootstrap";
import CollectionModal from "collections/components/CollectionModal";
import useCollectionMutation from "collections/hooks/useCollectionMutation";
import CurrentUser from "logic/users/CurrentUser";
const CreateCollectionButton = ({ bsSize = "md", bsStyle = "default", buttonText = "Create collection" }) => {
  const [showCreateModal, setShowCreateModal] = useState(false);
  const toggleCreateModal = useCallback(() => setShowCreateModal((cur) => !cur), []);
  const { createCollection } = useCollectionMutation();
  const onCreate = (values) => createCollection({
    share_request: values.share_request,
    entities: [],
    title: values.title,
    description: values.description,
    id: values.id
  }).then((collection) => CurrentUser.reload().then(() => collection));
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Button, { bsSize, bsStyle, onClick: toggleCreateModal }, buttonText), showCreateModal && /* @__PURE__ */ React.createElement(
    CollectionModal,
    {
      title: "Create collection",
      submitButtonText: "Create collection",
      submitLoadingText: "Creating collection...",
      onSubmit: onCreate,
      onClose: toggleCreateModal,
      create: true
    }
  ));
};
export default CreateCollectionButton;
